import { api } from "@/api";
import { QueryProps } from "@/types/Api";

export interface SportProviderOverride {
  sport_category: string;
  feed_type: "line" | "live";
  // null = explicit "no provider" (the sport/feed is closed).
  provider_id: number | null;
}

export const getSportProviders = async (
  props?: QueryProps
): Promise<SportProviderOverride[]> => {
  const res = await api.client.get("/settings/providers/sports", {
    signal: props?.signal,
  });
  return res.data;
};

export interface UpdateSportProviderParams {
  sportCategory: string;
  feedType: "line" | "live";
  // null = set this (sport, feed) to "no provider" (closed).
  providerId: number | null;
}

export const updateSportProviderSettings = async (
  params: UpdateSportProviderParams
): Promise<SportProviderOverride[]> => {
  const res = await api.client.put("/settings/providers/sports", params);
  return res.data;
};
